import { selectBasketDiscount, selectBasketDiscountCode, sendBasket, updateDiscountCode } from 'containers/OrderDetails/basketSlice'
import { useReduxDispatch, useReduxSelector } from 'store'
import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import Submit from 'components/inputs/Submit'
import { useHistory } from 'react-router-dom'
import Input from 'components/inputs/Input'
import Popup from 'components/popups/Popup'
import { useState } from 'react'
import './style.scss'

const priceList = [{
  "price_percentage": 100,
  "gross_price": "615.00",
  "v": "1m",
  "m": 1,
  "d": 0,
  "r": 0,
  "gross_price_d": "21.00",
  "net_price": "500.00",
  "net_price_d": "17.00",
  "selected": true
}, {
  "price_percentage": 100,
  "gross_price": "585.00",
  "v": "6m",
  "m": 6,
  "d": 0,
  "r": 50,
  "gross_price_d": "21.00",
  "net_price": "500.00",
  "net_price_d": "17.00"
}, {
  "price_percentage": 100,
  "gross_price": "550.00",
  "v": "12m",
  "m": 12,
  "d": 0,
  "r": 100,
  "gross_price_d": "21.00",
  "net_price": "500.00",
  "net_price_d": "17.00"
}]

const DiscountPopup = () => {
  const discountCode = useReduxSelector(selectBasketDiscountCode)
  const discount = useReduxSelector(selectBasketDiscount)
  const [value, setValue] = useState(discountCode || '')
  const [isSending, setSending] = useState(false)

  const { goBack } = useHistory()
  const dispatch = useReduxDispatch()
  const { t } = useTranslation('basket')

  return (
    <Popup>
      <div className='discounts__popup'>
        <div className='popup__title'>
          <div>{t('getADiscount')}</div>
          <div>{t('enterDiscountCode')}</div>
        </div>
        <Input
          value={value}
          name='discount'
          placeholder={t('discountCode')}
          changeHandler={e => {
            setValue(e.target.value)
          }}
        />

        {discount && <div className='discounts__popup__section__container'>
          <div className='discounts__popup__section'>
            <div className='discounts__popup__section__header'>{discount.title}</div>
            <div className='discounts__popup__section__content'>{discount.description}</div>
          </div>
          <i
            className='icon icon--trash'
            onClick={() => {
              setValue('')
              dispatch(updateDiscountCode(''))
              dispatch(sendBasket({ step: 'rentingSummary' }))
            }}
          />
        </div>}

        {value !== discountCode && <Submit
          isLoading={isSending}
          block={isSending || value.length === 0 || value === discountCode}
          text={t(discountCode && discountCode !== value ? 'change' : 'save')}
          action={() => {
            setSending(true)
            dispatch(sendBasket({ step: 'rentingSummary', discountCode: value })).then(res => {
              if (res.payload?.discount?.validate) {
                dispatch(updateDiscountCode(value))
              }
              setSending(false)
            })
          }}
        />}

        <div className='popup__title'>
          <div>{t('doYouKnowThat')}</div>
        </div>

        <div className='discounts__popup__section'>
          <div className='discounts__popup__section__header'>{t('thirdWarehouseForHalfThePrice')}</div>
          <div className='discounts__popup__section__content'>{t('whenRenting3OrMoreWarehousesAtOnceTheCheapestOneWillBe50Cheaper')}</div>
        </div>

        <div className='discounts__popup__section'>
          <div className='discounts__popup__section__header'>{t('freeShelfForThe5thWarehouse')}</div>
          <div className='discounts__popup__section__content'>{t('whenRenting5OrMoreWarehousesAtOnceYouWillGetAFreeShelf')}</div>
        </div>

        <div className='discounts__popup__section'>
          <div className='discounts__popup__section__header'>{t('theLongerYouStoreTheMoreYouGain')}</div>
          <div className='discounts__popup__section__content'>{t('monthlyRentalPriceChangesOverTime')}</div>
          <div className='discounts__popup__section__promotion'>
            {priceList.map(({ d, m, selected, gross_price, gross_price_d }, i) => <div
              key={i}
              className={`promotion__line center${selected ? ' --selected' : ''}`}>
              {m
                ? <div className={`promotion__label ${selected ? ' --selected' : ''}`}>
                  <span>{gross_price} zł</span>
                  <span className='--bottom'>{m} {t('month')}</span>
                </div>
                : <div className={`promotion__label ${selected ? ' --selected' : ''}`}>
                  <span>{gross_price_d} zł</span>
                  <span className='--bottom'>{d} {t('day')}</span>
                </div>}
            </div>)}
          </div>
        </div>

        <ArrowBtn
          enlarged
          text={t('finish')}
          showArrow={false}
          action={goBack}
        />
      </div>
    </Popup>
  )
}

export default DiscountPopup